import { Sun, Moon } from "lucide-react";

/**
 * Sun/Moon toggle for the reader theme on long-form pages.
 * Tone-aware: shows the icon you'd switch *to*.
 */
export function ReadThemeToggle({ theme, onToggle, "data-testid": testId = "read-theme-toggle", className = "" }) {
  const isDark = theme === "dark";
  // Color tokens — keeps contrast both ways
  const base = isDark
    ? "border-champ-light/20 text-bone hover:border-champ-light/50 hover:bg-bone/5"
    : "border-aubergine/20 text-aubergine hover:border-aubergine/50 hover:bg-aubergine/5";

  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid={testId}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-md border transition-colors ${base} ${className}`}
    >
      {isDark
        ? <Sun className="h-4 w-4" />
        : <Moon className="h-4 w-4" />}
    </button>
  );
}
